import PropTypes from "prop-types";
import * as React from "react";
import { IconButton, Menu, MoreVertIcon, Typography } from "../../../themeV2";
import DetailsSection from "../sections/DetailsSection";
import ImagesSection from "../sections/ImagesSection";
import css from "./create.module.css";

export const cardTitle = (card, index) => card.name || `Product ${index + 1}`;

const CardEditor = function CardEditor({
  card,
  index,
  otherCards,
  dispatch,
  uploader,
  problems,
  showErrors,
}) {
  const title = cardTitle(card, index);

  return (
    <li className={css.card}>
      <div className={css.cardHeader}>
        <Typography variant="title-md" as="h3">
          {title}
        </Typography>
        {otherCards.length > 0 && (
          <Menu.Root>
            <Menu.Trigger
              render={
                <IconButton
                  variant="text"
                  size="sm"
                  label={`Actions for ${title}`}
                />
              }
            >
              <MoreVertIcon />
            </Menu.Trigger>
            <Menu.Popup side="bottom" align="end">
              {card.images.length > 0 &&
                otherCards.map(({ card: other, index: otherIndex }) => (
                  <Menu.Item
                    key={other.cardId}
                    onClick={() =>
                      dispatch({
                        type: "moveImages",
                        fromCardId: card.cardId,
                        toCardId: other.cardId,
                      })
                    }
                  >
                    Move images to {cardTitle(other, otherIndex)}
                  </Menu.Item>
                ))}
              <Menu.Item
                onClick={() =>
                  dispatch({ type: "removeCard", cardId: card.cardId })
                }
              >
                Remove product
              </Menu.Item>
            </Menu.Popup>
          </Menu.Root>
        )}
      </div>
      <ImagesSection
        card={card}
        dispatch={dispatch}
        uploader={uploader}
        problems={problems}
        showErrors={showErrors}
      />
      <DetailsSection
        showHeading={false}
        card={card}
        problems={problems}
        showErrors={showErrors}
        onChange={(changes) =>
          dispatch({ type: "updateCard", cardId: card.cardId, changes })
        }
      />
    </li>
  );
};

CardEditor.propTypes = {
  card: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  otherCards: PropTypes.arrayOf(PropTypes.object).isRequired,
  problems: PropTypes.arrayOf(PropTypes.object).isRequired,
  showErrors: PropTypes.bool,
  uploader: PropTypes.object.isRequired,
};

export default CardEditor;
